import {Location} from './location';
import {Route} from './route';
import {RouteSchedule} from './route-schedule';

export class TransportIteraction {
  id: number;
  route: Route;
  isCustom: boolean;
  order: number;
  transportDirection: string | number;  // ['OneWay', 'RoundTrip'];
  date: string;
  stop: Location;
  schedule: RouteSchedule;
  exitStop: Location;
}



// WEBPACK FOOTER //
// ./src/app/shared/api/model/transport-iteraction.ts